import { whichTarget, isComeOtherRowMessage, removeDraggedComponent, common_splitRowFunc, removeNullElements, getRow, getMessage } from '../commons'
import { getType } from '../utils';

export default (state, indexes) => {
    let { currentEditMessage, currentEditSlidePage } = state
    const { rowIndexDetail, slidePageIndex } = indexes // Index for group component slide page
    const editTargetFlag = slidePageIndex || slidePageIndex === 0 && rowIndexDetail || rowIndexDetail === 0 && currentEditSlidePage
    const editState = editTargetFlag ? 'SLIDE_PAGE' : 'MESSAGE'
    let editTarget = editTargetFlag ? [currentEditSlidePage] : currentEditMessage
    /**
     * Index 요소 관련
     * message_index는 참조 기준(0부터)으로 잡혀있음
     * row_index, component_index는 사용자 기준(1부터)으로 잡혀있음
     */
    const { message_index_dragged, row_index_dragged, component_index_dragged } = indexes // Dragged component (source)
    const { message_index_target, row_index_target, component_index_target } = indexes // Target index position (target)
    const message_index_dragged_calc = editTargetFlag ? 0 : message_index_dragged // For group slide page
    const message_index_target_calc = editTargetFlag ? 0 : message_index_target // For group slide page
    // const row_index_target_calc = editTargetFlag ? row_index_target : row_index_target // For group slide page
    const row_index_target_calc = editTargetFlag ? rowIndexDetail : row_index_target // For group slide page

    const target = whichTarget(message_index_target_calc, row_index_target_calc, component_index_target)

    // const dragged_component = currentEditMessage[message_index_dragged].rows[row_index_dragged].components[component_index_dragged]

    const detect = isComeOtherRowMessage({...indexes,
      message_index_dragged: message_index_dragged_calc,
      message_index_target: message_index_target_calc,
      // row_index_dragged: row_index_dragged, 
      row_index_target: row_index_target_calc,
    })
    // console.log('=== UPDATE_COMPONENT_INDEX_POS ===')
    // console.log('=== index info ===')
    // console.log('=== dragged index infos ===')
    // console.log('message_index_dragged_calc :', message_index_dragged_calc);
    // console.log('row_index_dragged :', row_index_dragged);
    // console.log('component_index_dragged :', component_index_dragged);
    // console.log('=== dropped index infos ===')
    // console.log('message_index_target_calc :', message_index_target_calc);
    // console.log('row_index_target_calc :', row_index_target_calc);
    // console.log('component_index_target :', component_index_target);
    
    // Common logic (prefix/type)
    const draggedRow = editTarget[message_index_dragged_calc].rows[row_index_dragged]
    const draggedComponent = editTarget[message_index_dragged_calc].rows[row_index_dragged].components[component_index_dragged]
    let prefix_type, type = null
    if (draggedRow) {
      const type_result = getType(draggedRow.attr)
      prefix_type = type_result.prefix
      type = type_result.type
    }

    switch(target) {
      case "COMPONENT":
        // Pass message, row index
        editTarget = editTarget.map((message, i) => {
          let { rows } = message
          let row_split_new_row = null // Row has inserted component (between rows)
          let row_split_splitted_row = null // Row has splitted components
          let first_splitted_row = null // Row has splitted components
          // console.log("===== Dragged process START =====")
          /**
           * Dragged to other element process case
           * 드래그 된 컴포넌트를 전처리에서 삭제함, 해당 컴포넌트의 위치는 null로 채워짐 (Index 유지)
           */
          if (message_index_dragged_calc === i && detect.result) {
            // console.log('수정 할 message detect :', message);
            rows = removeDraggedComponent(rows, row_index_dragged, component_index_dragged)
            // rows = removeNullElements(rows)
            // console.log('수정 후 rows :', rows);
          }
          // console.log("===== Dragged process END =====")

          // console.log('result rows :', rows);

          // console.log("===== Target process START =====")
          // Target process
          if (message_index_target_calc === i) {
            rows = rows.map((row, i) => {
              if (!row) { // index유지를 위해 null값으로 유지함, remove blank rows 과정을 후처리로 옮겨 null detect 처리
                return null
              }
              let { components, attr } = row
              // Target process
              if (row_index_target_calc === i) {
                // const dragged_component = components[component_index_dragged]
                // Row split condition
                if (attr !== prefix_type+'/'+type) {
                  const _component_index = component_index_target === -1 ? 0 : component_index_target+1 // index -1 means index 0 
                  // console.log('_component_index :', _component_index);
                  const { firstSplittedRow, newRow, splittedRow } = common_splitRowFunc(row, _component_index, prefix_type, type, [draggedComponent])
                  row_split_new_row = newRow
                  row_split_splitted_row = splittedRow
                  first_splitted_row = firstSplittedRow
                  return firstSplittedRow
                }

                if (component_index_target === -1) { // Component target index === -1
                  // console.log("컴포넌트 타겟 인덱스 === -1")
                  row = {...row, components: [draggedComponent, ...components.filter((com) => (com.local_id !== draggedComponent.local_id))]}
                } else { // Component target index === etc..
                  const updated_components = []
                  components.some((component, i) => {
                    // From other element
                    if (detect.result) {
                      updated_components.push(component)
                      if (component_index_target === i) {
                        updated_components.push(draggedComponent)
                      }
                    } else {
                      if (component_index_dragged !== i) {
                        // console.log("push default: ", component)
                        updated_components.push(component)
                      } 
                      if (component_index_target === i) {
                        updated_components.push(draggedComponent)
                      }
                    }
                  })
                  // console.log('updated_components :', updated_components);
                  row = {...row, components: updated_components}
                }
              }
              return row
            })

            const my_row_index = row_index_target_calc === -1 ? 0 : first_splitted_row ? row_index_target_calc+1 : row_index_target
            /**
             * Splice splitted rows 
             * Note: splice condition으로 인해 else if 사용하게 되었음
             */
            if (row_split_new_row && row_split_splitted_row) {
              // row_index_target === -1 ? 0 : first_splitted_row ? row_index_target+1 : row_index_target
              rows.splice(my_row_index, 0, row_split_new_row, row_split_splitted_row)
            } else if (row_split_new_row && !row_split_splitted_row) {
              rows.splice(my_row_index, 0, row_split_new_row)
            }

            rows = removeNullElements(rows) // remove blank rows
            // console.log("After removeNullElements rows -> ", rows)
            
            message = {...message, rows: rows,}
          }
          // console.log("===== Target process END =====")

          // console.log('Result rows :', rows);
          // console.log('Result message :', message);


          rows = removeNullElements(rows) // remove blank rows
          // row.length <= compare then return null(message)
          if (rows) {
            if (rows.length <= 0) {
              return null
            }
          }
          return {
            ...message,
            rows: rows,
          }
        })
        // reference components row
        break;

      case "ROW":
        // console.log("=== START MESSAGE ROUTINE ===")
        editTarget = editTarget.map((message, i) => {
          let { rows } = message
          if (i === message_index_dragged_calc) {
            rows = removeDraggedComponent(rows, row_index_dragged, component_index_dragged)
          }
          // console.log('removed rows :', rows);
          // console.log("===== Target process START =====")
          // Target process
          if (message_index_target_calc === i) {
            const updated_rows = []
            // console.log("=== START ROW ROUTINE ===")
            if (row_index_target_calc === -1) {
              let created_row = getRow(prefix_type, "_"+type)
              created_row = {
                ...created_row,
                components: [draggedComponent]
              }
              updated_rows.push(created_row)
            }

            rows.map((row, i) => {
              // console.log('row :', row);
              // Target process
              if (row) {
                updated_rows.push(row)
              }
              // !!TODO 0번째 인덱스로 옮겼을 시 처리가 필요한 것 같음 !!
              // console.log('ROUTINE row :', row);
              if (row_index_target_calc === i) {
                // console.log(row_index_target, '===', i)
                let created_row = getRow(prefix_type, "_"+type)
                created_row = {
                  ...created_row,
                  components: [draggedComponent]
                }
                updated_rows.push(created_row) // Component menu type 맞춤
                // origin code !!MUST EXPLAIN(_NORMAL_TEXT)? // updated_rows.push(getRow("_"+prefix_type, "_"+type)) // Component menu type 맞춤
              }
            })

            message = {...message, rows: updated_rows,}
            // console.log('Result message :', message);
            return message
          }
          rows = removeNullElements(rows)
          if (rows) {
            if (rows.length <= 0) {
              return null
            }
          }
          return {
            ...message,
            rows: rows,
          }
          // console.log("===== Target process END =====")
        })
        break;

      case "MESSAGE":
        // const draggedRow = editCurrentMessage[message_index_dragged_calc].rows[row_index_dragged]
        let createdMessageInstance = getMessage(prefix_type, type, null, [draggedComponent]) // Option parameter ([draggedComponent])
        // Remove dragged component
        editTarget = editTarget.map((message, i) => {
          if (i === message_index_dragged_calc) {
            let { rows } = message
            rows = removeDraggedComponent(rows, row_index_dragged, component_index_dragged)
            return {...message,
              rows: rows,
            }
          }
          return message
        })

        // Target index 0
        if (message_index_target_calc === 0) {
          // createdMessageInstance["rows"]
          editTarget = [createdMessageInstance].concat(editTarget)
        } else { // Target 1, 2, 3 ...
          editTarget.splice(message_index_target_calc, 0, createdMessageInstance)
          editTarget = editTarget.map(message => (message)) // TODO 최적화 immutable 관련 
        }
        // console.log("editTarget result -> ", editTarget)
        
        // Remove rows nulls, rows.length === 0 compare
        editTarget = editTarget.map(message => {
          let { rows } = message
          rows = removeNullElements(rows)
          // row.length is 0 or under then return null (after remove)
          if (rows) {
            if (rows.length <= 0) {
              return null
            }
          }
          return {
            ...message,
            rows: rows,
          }
        })
        break;

      default:
        console.error("whichTarget에서 제공한 Target type contant value는 정의되지 않았음 => ", target)
        return {  
          ...state,
        }
    }

    // 메시지 row.length === 0 삭제 필요
    editTarget = removeNullElements(editTarget)
    if (editTargetFlag) {
      return {
        editState: editState,
        result: editTarget[0],
      }
    }
    return {
      editState: editState,
      result: editTarget,
    }
  }